import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { ErrorMessage, ValidMessage } from '@atlaskit/form';

import { convertLegacyColor } from '../../../common/utils';

import { messages } from './messages';

type ColorValidationMessagesProps = {
	selectedColor: string;
	preSelectedColor?: string;
	showConfirmation: boolean;
	isReadableColor?: (color: string) => boolean;
	validationFailMessage?: string;
	validationSuccessMessage?: string;
};

export const ColorValidationMessages = ({
	selectedColor,
	isReadableColor,
	showConfirmation,
	preSelectedColor,
	validationFailMessage,
	validationSuccessMessage,
}: ColorValidationMessagesProps) => {
	const convertedColor = convertLegacyColor(selectedColor);
	const isInvalid = !convertedColor.isValid();

	if (isInvalid || !preSelectedColor) {
		return (
			<ErrorMessage>
				<FormattedMessage {...messages.errorMessage} />
			</ErrorMessage>
		);
	}

	if (showConfirmation) {
		return (
			<ValidMessage>
				<FormattedMessage {...messages.confirmationMessage} />
			</ValidMessage>
		);
	}

	if (isReadableColor) {
		if (isReadableColor(selectedColor)) {
			return (
				<ValidMessage>
					{validationSuccessMessage || <FormattedMessage {...messages.contrastRatioPassMessage} />}
				</ValidMessage>
			);
		}
		return (
			<ErrorMessage>
				{validationFailMessage || <FormattedMessage {...messages.contrastRatioFailMessage} />}
			</ErrorMessage>
		);
	}

	return null;
};
